import React, { useState, useEffect } from 'react';
import { PitchDetails } from '../../services/pitches';
import styled from 'styled-components';
import PitchProperties from './PitchProperties';
import PitchSessions from './PitchSessions';
import PitchSessionVideos from './PitchSessionVideos';

interface Props {
  pitch: PitchDetails;
  edit: boolean;
}

const PitchDetail: React.FunctionComponent<Props> = (props) => {
  const [session, setSession] = useState<string | undefined>();

  useEffect(() => {
    setSession(undefined);
  }, [props.pitch.id]);

  return (
    <div>
      <Container>
        <Box className="sciui-card sciui-m-l-l sciui-m-r-m sciui-p-l sciui-bg-p-5">
          <PitchProperties pitch={props.pitch} />
        </Box>
        <Box className="sciui-card sciui-m-l-m sciui-m-r-l sciui-p-l sciui-bg-p-5">
          <PitchSessions pitch={props.pitch} selectedSession={session} setSelectedSession={setSession} />
        </Box>
      </Container>
      {session && (
        <div className="sciui-grid sciui-m-b-l">
          <div className="sciui-grid-item-m-12 sciui-grid-item-l-12">
            <div className="sciui-card sciui-m-x-l sciui-p-l sciui-bg-p-5">
              <PitchSessionVideos session={session} pitch={String(props.pitch.id)} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: row;
`;

const Box = styled.div`
  width: 50%;
  flex: 1;
  margin-top: 32px;
  margin-bottom: 32px;
`;

export default PitchDetail;
